export const itemdimensionanalysisConstant = {

    GET_ITEM_DETAILS_REQUEST: "GET_ITEM_DETAILS_REQUEST",
    GET_ITEM_DETAILS_SUCCESS: "GET_ITEM_DETAILS_SUCCESS",
    GET_ITEM_DETAILS_FAILURE: "GET_ITEM_DETAILS_FAILURE",
    GET_ITEM_SUMMARY_REQUEST: "GET_ITEM_SUMMARY_REQUEST",
    GET_ITEM_SUMMARY_SUCCESS: "GET_ITEM_SUMMARY_SUCCESS",
    GET_ITEM_SUMMARY_FAILURE: "GET_ITEM_SUMMARY_FAILURE",
    RESET_ITEM_DETAILS_STATUS:"RESET_ITEM_DETAILS_STATUS",

    RESET_API_MESSAGES: "RESET_API_MESSAGES",
    RESET_ITEM_DETAILS: "RESET_ITEM_DETAILS",
};